export default __webpack_public_path__ + "static/media/ty.62d8c1b6.svg";